import React, {Component} from 'react';
import BackEnd from "../../../../backend/BackEnd";
import Moment from "react-moment";
import Pager from "../../../../controls/Pager";
import {Link} from "react-router-dom";
import NumberFilter from "../../../../datagrid/NumberFilter";
import DataGrid from "../../../../datagrid/DataGrid";
import DataColumn from "../../../../datagrid/DataColumn";

class AllTenderList extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {};

    render() {
        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>
                                <span className="text-muted font-weight-light">
                                <i className="px-nav-icon ion-cube"/>Тендеры /
                                </span> Все заказы
                            </h1>
                        </div>
                    </div>
                </div>
                <DataGrid dataSource={new BackEnd.TenderGrid.GetGridItems()}
                          gridId="AllTenderGrid"
                          pageSize={10}>
                    <DataColumn fieldName="tenderNumber" type="string"
                                caption="Номер тендерной заявки"
                                cell={tender =>
                                    <Link to={`/tenders/${tender.tenderId}`}>
                                        {tender.tenderNumber}
                                    </Link>
                                }/>
                    <DataColumn fieldName="state" type="string"
                                caption="Статус"
                                cell={tender => tender.state.text}/>
                    <DataColumn fieldName="type" type="string"
                                caption="Тип"
                                cell={tender => tender.type.text}/>
                    <DataColumn fieldName="deliveryDate" type="date"
                                caption="Дата доставки"
                                cell={tender =>
                                    tender.deliveryDate && <Moment>{tender.deliveryDate}</Moment>
                                }/>
                    <DataColumn fieldName="finalRecipient" type="string"
                                caption="Конечный получатель"
                                cell={tender => tender.finalRecipient}/>
                    <DataColumn fieldName="supplier" type="string"
                                caption="Поставщик"
                                cell={tender => tender.supplier ? tender.supplier.text : ''}/>
                    <DataColumn fieldName="clientRate" type="number"
                                caption="Ставка клиента"
                                cell={tender =>
                                    tender.clientRate
                                        ? `${tender.clientRate} ${tender.clientRateType}`
                                        : ''
                                }/>
                    <DataColumn fieldName="supplierRate" type="number"
                                caption="Ставка поставщика"
                                cell={tender =>
                                    tender.supplierRate
                                        ? `${tender.supplierRate} ${tender.supplierRateType}`
                                        : ''
                                }/>
                    <DataColumn fieldName="orderNumber" type="string"
                                caption="Номер заказа"
                                cell={tender => tender.orderNumber}/>
                    <DataColumn fieldName="purchaseOrderNumber" type="string"
                                caption="Номер заказа на закупку"
                                cell={tender => tender.purchaseOrderNumber}/>
                    <DataColumn fieldName="deliveryType" type="string"
                                caption="Доставка"
                                cell={tender => tender.deliveryType ? tender.deliveryType.text : ''}/>
                    <DataColumn fieldName="client" type="string"
                                caption="Клиент"
                                cell={tender => tender.client ? tender.client.text : ''}/>
                    <DataColumn fieldName="paymentConditions" type="string"
                                caption="Условия оплаты"
                                cell={tender => tender.paymentConditions ? tender.paymentConditions.text : ''}/>
                    <DataColumn fieldName="driver" type="string"
                                caption="ФИО водителя"
                                cell={tender => tender.driver}/>
                    <DataColumn fieldName="driverPhoneNumber" type="string"
                                caption="Телефон водителя"
                                cell={tender => tender.driverPhoneNumber}/>
                    <DataColumn fieldName="vehicle" type="string"
                                caption="Данные ТС"
                                cell={tender => tender.vehicle}/>
                    <DataColumn fieldName="supplierDocumentsFlag" type="string"
                                caption="Документы поставщика"
                                cell={tender => tender.supplierDocumentsFlag}/>
                    <DataColumn fieldName="clientDocumentsFlag" type="string"
                                caption="Документы клиента"
                                cell={tender => tender.clientDocumentsFlag}/>
                    <DataColumn fieldName="paymentFlag" type="string"
                                caption="Оплата"
                                cell={tender => tender.paymentFlag}/>
                    <DataColumn fieldName="comment" type="string"
                                caption="Комментарий"
                                cell={tender => tender.comment}/>
                    <DataColumn fieldName="productCode" type="string"
                                caption="Код артикула"
                                cell={tender =>
                                    <span style={{color: tender.hasProduct ? 'inherit' : 'red'}}>
                                        {tender.productCode}
                                    </span>
                                }/>
                    <DataColumn fieldName="count" type="number"
                                caption="Количество"
                                cell={tender => tender.count}/>
                    <DataColumn fieldName="countFact" type="number"
                                caption="Фактически принятое количество"
                                cell={tender => tender.countFact}/>
                    <DataColumn fieldName="createdAt" type="date"
                                caption="Дата создания"
                                cell={tender =>
                                    <Moment>{tender.createdAt}</Moment>
                                }/>
                    <DataColumn fieldName="deliveryAddress" type="string"
                                caption="Адрес доставки"
                                cell={tender => tender.deliveryAddress}/>
                </DataGrid>
            </div>
        );
    }
}

export default AllTenderList;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/Tenders/All/AllTenderList.js